<template>
  <div class="footer">
    <div class="text-center">
        &copy; {{ new Date().getFullYear() }} <span style="color: #FF8F00;">Beyond Pulse {{ $t('OUTER_PAGES.footer')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingFooter'
}
</script>
